import React, { useEffect, useState, useRef } from "react";
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './Assess_etc_app.scss';
import HongButton from "../comm/HongButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Checkbox from '@mui/material/Checkbox';
import HeaderTitle from "../comm/HeaderTitle";


const Assess_etc_app = () => {
    const userInfo = useSelector((state) => state.reduxIgong.userInfo);
    const selectedTestCode = useSelector((state) => state.reduxIgong.selectedTestCode);
    const selectedStCode = useSelector((state) => state.reduxIgong.selectedStCode);
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);//체크박스
    const [selectedItemsType, setSelectedItemsType] = useState([]);//체크박스


    useEffect(() => {
        fncQuestion();
    }, []);

 
    function fncQuestion() {//설문조사 학부모 교사
        fnc.sendAxios('/igonAssess_etcRoutes/select/question', { }, (res) => {
          if (res && res.length > 0) {
           const listRes = getRecords(res);
           setList(listRes);
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }



    function getRecords(res) {
        let records = [];

        for (let i = 0; i < res.length; i++) {  
            const sno= res[i]["no"];    
            const no= res[i]["no2"];
            const title = res[i]["title"];
            const code = res[i]["code"];
            const no2 = res[i]["no2"];
            const type = res[i]["no3"];
            const que = res[i]["que"];
            const score = res[i]["score"];
    
            records.push({ sno, no, title, code, no2, type, que, score });
        }
        return records;
      }



    function handleCheckboxChange(item) {
        // 같은 no 그룹 내 기존 선택 항목 제거(방식1)
        // const newSelectedItems = selectedItems.filter(sno => {
        //     const foundItem = list.find(i => i.sno === sno);
        //     return foundItem?.no !== item.no;
        // });

        // 같은 no 그룹 내 기존 선택 항목 제거(방식2)
        const newSelectedItems = selectedItems.filter(selected => {
            const foundItem = list.find(i => i.sno === selected.sno);
            return foundItem?.no !== item.no;
        });
    
        // 현재 항목 추가
        // newSelectedItems.push(item.sno);
        newSelectedItems.push({sno: item.sno, code: item.code, value: item.type})
        setSelectedItems(newSelectedItems);
        console.log(newSelectedItems, 'newSelectedItems');
    }

    
    function handleSubmit() {

        const groupCount = new Set(list.map(item => item.no)).size;// 전체 문항 그룹 수(new Set([...]) 중복제거 해서 넣음)

        if (selectedItems.length !== groupCount) {
            alert('모든 문항 그룹에서 하나씩 선택해주세요.');
            return;
        }
    
        const rtn = window.confirm('제출하시겠습니까?');
        if (!rtn) return; 
        const testDate = fnc.fncDate();
        // const stCode = userInfo.stCode;//학생일때는 추가 하도록
        const stCode = selectedStCode;
        const testCode = fnc.fncSirialNum('ET');
        const pTestCode = selectedTestCode;
        fncInsert_marking(pTestCode, testDate, stCode, testCode );
    }
    

    
    function fncInsert_marking(pTestCode, testDate, stCode, testCode ) {

        fnc.sendAxios('/igonAssess_etcRoutes/insert/etc_marking', { pTestCode, testDate, stCode, testCode }, (res) => {
                if (res) {
                if (res.success === 'exist') {
                    alert(`${testDate}에 제출한 진단이 이미 존재합니다.`);
                } else if (res.success === true) {
                    fncInsert_marking_value_total(pTestCode, testCode, stCode);
                }
                } else {
                alert('저장에 실패했습니다.');
                }
        });
    }
                
        
    
    
    function fncInsert_marking_value_total(pTestCode, testCode, stCode) {

        let cnt = 0;
        const tCnt = selectedItems.length;

        selectedItems.forEach((item, index) => {
            const value = item.value;
            const munCode = item.code;
    
                fncInsert_marking_value(pTestCode, testCode, stCode, munCode, value, () => {       
                    cnt ++;
                    if (cnt == tCnt) {
                        alert('완료되었습니다.'); 

                        fncGoto_assess_book_app();
                        // navigate(-1);    
                        // if (isToken) {
                        //     navigate('/myRoomSt');    
                        // } else {
                        //     navigate(-1);    
                        // }
                        
                    }
                });
    
            });

            
            function fncInsert_marking_value(pTestCode, testCode, stCode, munCode, value, callback) {
                fnc.sendAxios('/igonAssess_etcRoutes/insert/etc_marking_value', { 
                    pTestCode, testCode, stCode, munCode, value, callback}, (res) => {
                    if (res) {
                        callback();
                    } else {
                        alert('저장에 실패했습니다.');
                    }
                });
            }
    }
    
    function handleClose() {
        navigate(-1);
    }
    
    function fncGoto_assess_book_app() {

            // dispatch(setSelectedStCode(item.stCode));
            // dispatch(setSelectedTestCode(item.testCode));
            navigate('/assess_book_app');
    }
 
    //=============================================
    return (
            <S.Section>
             <HeaderTitle  title={'학업역량 진단평가'} direction={1} onBackClick={ handleClose} />
            <div className="Assess_etc_app">
                <div className='wrap-main'>
                <section className='section-list'>
                    
                <table className="table-hong">
                    <thead>
                        <tr>
                            <th>no</th>
                            <th>구분</th>
                            <th>질의내용</th>
                            <th>체크</th>
                        
                        </tr>            
                    </thead>
                    
                    <tbody>
                    {
                        Object.entries(
                        list.reduce((acc, item) => {
                            acc[item.no] = acc[item.no] || [];
                            acc[item.no].push(item);
                            return acc;
                        }, {})
                        ).map(([no, groupItems], groupIndex) => (
                        groupItems.map((item, index) => (
                            <tr
                            className={`${groupIndex % 2 === 0 ? 'group-highlight' : ''}`}
                            key={item.sno}
                            >
                            {index === 0 && (
                                <td className="no" rowSpan={groupItems.length}>{item.no}번</td>
                            )}
                            <td>{item.type}</td>
                            <td className={`text-left cusor-pointer
                                 ${selectedItems.some(selected => selected.sno === item.sno) ? 'text-red' : ''
                                }`}
                            onClick={() => handleCheckboxChange(item)}  // ✅ 클릭 시 체크박스 토글
                            >
                            {item.que}
                            </td>

                            <td className="text-center">
                                <Checkbox
                                className="custom-checkbox"
                                // checked={selectedItems.includes(item.sno)}
                                checked={selectedItems.some(selected => selected.sno === item.sno)}
                                onChange={() => handleCheckboxChange(item)}
                                />
                            </td>
                            </tr>
                        ))
                        ))
                    }
                    </tbody>
                </table>
                </section>

              
                </div>
                
                <div className="box-menu">
                    <HongButton className="btn h-btn-red" onClick={handleSubmit}>제출</HongButton>
                </div>
     
                
            </div>
        
            </S.Section>

    );
};

export default Assess_etc_app;
